<template>
  <div>
    <el-drawer
      :visible.sync="showDialog"
      direction="rtl"
      size="100%"
      :modal="false"
      @close="closeDialog"
      :wrapperClosable="false"
    >
      <!-- :visible.sync="showDialog" width="60%" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="dialog_box" -->
      <div class="chat_container ChatPage">
        <itemTalk />
        <div class="header">
          <JwChat-item
            :config="config"
            :showTrackPopup="showTrackPopup"
            @addTag="bindAddTag"
            @updateNickname="updateNickname"
            @updateMarks="updateMark"
            @copyAlltext="copyAlltext"
            @copyTraces="copyTraces"
            @changeTrackPopup="changeTrackPopup"
            @closeDrawer="closeDialog"
          />
          <slot name="header" />
        </div>
        <div class="header_line"></div>
        <div class="chatBox">
        <div
          class="key_container"
          v-show="keyInfo.keyword && keyInfo.from_url && keyInfo.site_name"
        >
          <div class="key_div">
            <div class="keyword">
              <label class="key_lb" v-show="keyInfo.query"
                >访客搜索：{{ keyInfo.query ? keyInfo.query : "无" }}
              </label>
              <label class="key_lb">关键字：{{ keyInfo.keyword }}</label>
            </div>
            <div class="otherInfo">
              <div style="width: 50%; display: flex">
                <label class="brow_lb">当前浏览：</label
                ><label class="url_lb">
                  <el-popover
                    placement="bottom"
                    class="url_lb"
                    width="300"
                    trigger="hover"
                  >
                    <div class="url-allShow">
                      <span> {{ keyInfo.from_url }}</span>
                      <span class="url-copy" @click="copyText(keyInfo.from_url)"
                        >点击复制链接</span
                      >
                    </div>
                    <label
                      class="url_lb"
                      style="display: inline-block"
                      @contextmenu.prevent.stop="copyText(keyInfo.from_url)"
                      slot="reference"
                    >
                      {{ keyInfo.from_url }}
                    </label>
                  </el-popover></label
                >
              </div>
              <label class="site_lb" v-if="!$store.state.isShowIp">所属站点：{{ keyInfo.site_name }}</label>
              <label class="site_lb" v-else>访客IP：{{ visitorIp }}</label>
            </div>
            <div class="history_div" @click="getHistoryAction">
              <img
                class="history_img"
                src="../../static/talks/t_history.png"
                style="width: 18px; height: 18px"
              />
              <label class="history_lb">查看历史消息</label>
            </div>
          </div>
        </div>

        <div
          class="key_container1"
          v-show="
            (!keyInfo.keyword && keyInfo.from_url && keyInfo.site_name) ||
            (keyInfo.keyword && !keyInfo.from_url && keyInfo.site_name) ||
            (keyInfo.keyword && keyInfo.from_url && !keyInfo.site_name)
          "
        >
          <div class="key_div1">
            <div class="keyword1">
              <label class="key_lb1" v-show="keyInfo.query"
                >访客搜索：{{ keyInfo.query ? keyInfo.query : "无" }}</label
              >
              <label class="key_lb1" v-show="keyInfo.keyword"
                >关键字：{{ keyInfo.keyword ? keyInfo.keyword : "无" }}</label
              >
              <label class="brow_lb1" v-show="keyInfo.from_url"
                >当前浏览：</label
              >
              <!--悬浮弹窗 完整地址显示框 -->
              <el-popover
                placement="bottom"
                class="url_lb"
                width="300"
                trigger="hover"
              >
                <div class="url-allShow">
                  <span> {{ keyInfo.from_url }}</span>
                  <span class="url-copy" @click="copyText(keyInfo.from_url)"
                    >点击复制链接</span
                  >
                </div>
                <label
                  class="url_lb"
                  style="display: inline-block"
                  @contextmenu.prevent.stop="copyText(keyInfo.from_url)"
                  slot="reference"
                >
                  {{ keyInfo.from_url }}
                </label>
              </el-popover>
              <label class="site_lb1" v-show="(keyInfo.site_name && !$store.state.isShowIp)"
                >所属站点：{{ keyInfo.site_name }}</label
              >
              <label class="site_lb1" v-show="(visitorIp && $store.state.isShowIp)"
                >访客IP：{{ visitorIp }}</label
              >
            </div>
            <div class="history_div" @click="getHistoryAction">
              <img
                class="history_img"
                src="../../static/talks/t_history.png"
                style="width: 18px; height: 18px"
              />
              <label class="history_lb">查看历史消息</label>
            </div>
          </div>
        </div>

        <div
          class="key_container2"
          v-show="
            (!keyInfo.keyword && !keyInfo.from_url && keyInfo.site_name) ||
            (keyInfo.keyword && !keyInfo.from_url && !keyInfo.site_name) ||
            (!keyInfo.keyword && keyInfo.from_url && !keyInfo.site_name)
          "
        >
          <div class="key_div2">
            <div class="keyword2">
              <label class="key_lb2" v-show="keyInfo.query"
                >访客搜索：{{ keyInfo.query }}</label
              >
              <label class="key_lb2" v-show="keyInfo.keyword"
                >关键字：{{ keyInfo.keyword }}</label
              >
              <label class="brow_lb2" v-show="keyInfo.from_url"
                >当前浏览：</label
              ><label class="url_lb"
                ><!--悬浮弹窗 完整地址显示框 -->
                <el-popover
                  placement="bottom"
                  class="url_lb"
                  width="300"
                  trigger="hover"
                >
                  <div class="url-allShow">
                    <span> {{ keyInfo.from_url }}</span>
                    <span class="url-copy" @click="copyText(keyInfo.from_url)"
                      >点击复制链接</span
                    >
                  </div>
                  <label
                    class="url_lb"
                    style="display: inline-block"
                    @contextmenu.prevent.stop="copyText(keyInfo.from_url)"
                    slot="reference"
                  >
                    {{ keyInfo.from_url }}
                  </label>
                </el-popover></label
              >
              <label class="site_lb2" v-show="(keyInfo.site_name && !$store.state.isShowIp)"
                >所属站点：{{ keyInfo.site_name }}</label
              >
              <label class="site_lb2" v-show="(visitorIp && $store.state.isShowIp)"
                >访客IP：{{ visitorIp }}</label
              >
            </div>
            <div class="history_div" @click="getHistoryAction">
              <img
                class="history_img"
                src="../../static/talks/t_history.png"
                style="width: 18px; height: 18px"
              />
              <label class="history_lb">查看历史消息</label>
            </div>
          </div>
        </div>
        <div class="taleBox" ref="scrollNode">
          <chatList
            ref="chatlist"
            :list="historyList"
            @loadHistory="loadHistoryHandler"
            :source="1"
          />
        </div>
      </div>
      </div>
    </el-drawer>
    <el-dialog
      title=""
      class="tag_dialog"
      v-if="isAddTag"
      :visible.sync="isAddTag"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        class="common_div"
        v-if="(usedTagList != null) & (usedTagList.length > 0)"
      >
        <label class="tag_lb">常用标签</label>
        <div class="tag_box">
          <div
            v-for="(item, index) in usedTagList"
            :key="index"
            size="small"
            @click="chooseTag(0, index)"
          >
            <div class="tag_btn" v-if="!item.selected">{{ item.name }}</div>
            <div
              v-else
              class="tag_selected"
              :style="{
                'border-color': '#' + item.color,
                color: '#' + item.color,
              }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="all_div">
        <label class="tag_lb">所有标签</label>
        <div class="tag_box">
          <div
            v-for="(item, index) in allTagList"
            :key="index"
            size="small"
            @click="chooseTag(1, index)"
          >
            <div class="tag_btn" v-if="!item.selected">{{ item.name }}</div>
            <div
              v-else
              class="tag_selected"
              :style="{
                'border-color': '#' + item.color,
                color: '#' + item.color,
              }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isAddTag = false" size="small">取 消</el-button>
        <el-button type="primary" @click="setTagAction" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="修改昵称"
      :visible.sync="UpdateNickname"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-input
        v-model="NickName"
        placeholder="请输入昵称"
        maxlength="30"
        style="width: 60%"
        clearable
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateNickname = false">取 消</el-button>
        <el-button type="primary" @click="updateNickRequest(0)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="修改备注"
      :visible.sync="UpdateMarkname"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-input
        v-model="MarkName"
        placeholder="请输入备注"
        style="width: 100%"
        maxlength="40"
        show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateMarkname = false">取 消</el-button>
        <el-button type="primary" @click="updateNickRequest(1)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      width="50%"
      lock-scroll
      :visible.sync="showTrackPopup"
      @close="closeTrackPopup"
      :close-on-click-modal="false"
      top="15vh"
    >
      <template slot="title">
        <span class="el-dialog__title">访客轨迹</span>
      </template>

      <div class="trackList">
        <div v-for="(item, index) in alltrackList" :key="index">
          <span :style="{ color: item.color1 }">{{ item.text1 }}</span
            ><span :style="{ color: item.color2 }"> {{ item.text2 }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import chatList from "../components/Chat/chatList.vue";
import itemTalk from "@/components/Chat/itemTalk";
export default {
  name: "chatDetail",

  props: ["isShow", "item"],

  components: {
    chatList,
    itemTalk,
  },

  data() {
    return {
      showDialog: this.isShow,
      selectItem: this.item,

      //header头部数据源
      config: {
        name: "",
        ipdress: "",
        number: "4",
        tags: [],
        mark: "",
        itype: "1",
        callback: this.bindCover,
        historyConfig: {
          tip: "", //'加载更多',
          callback: this.bindLoadHistory,
        },
        cid: "",
        sid: "",
        source: "",
        aduserId: "",
        sourceProvince: "",
        sourceCity: "",
      },

      keyInfo: {},
      //分页
      currentPage: 1,
      pageSize: 99,
      totalPage: 0,
      historyList: [],
      isToTop: true, //true-向上滚动 false-向下滚动
      allTagList: [],
      usedTagList: [],
      selectedTagList: [],
      userData: this.userInfo,
      isAddTag: false,
      UpdateNickname: false,
      NickName: "",
      UpdateMarkname: false,
      MarkName: "",
      sourceMap: {
        0: "其他",
        1: "百度",
        2: "360",
        3: "搜狗",
        4: "神马",
      },
      allText: "",
      allTraces: "",
      showTrackPopup: false,
      alltrackList: [],
      allTList:[],
    };
  },

  watch: {
    isShow(newVal, oldVal) {
      console.log("chatDetail isShow newVal = ", newVal);
      console.log("chatDetail isShow oldVal = ", oldVal);
      this.showDialog = newVal;
    },

    item(newVal, oldVal) {
      console.log("chatDetail item newVal = ", newVal);
      console.log("chatDetail item oldVal = ", oldVal);
      this.selectItem = newVal;
      this.historyList = [];
      this.currentPage = 1;
      console.log("chatDetail this.config = ", this.config);
      if (this.selectItem !== null) {
        this.isToTop = false;
        if (this.selectItem.source === "") {
          this.config.source = "未知";
        } else {
          // this.config.source=this.selectItem.source
          this.config.source = this.selectItem.source;
        }

        if (this.selectItem.aduserId === "") {
          this.config.aduserId = "无";
        } else {
          this.config.aduserId = this.selectItem.aduserId;
        }
        this.config.cid = this.selectItem.cid;
        this.config.sid = this.selectItem.sid;
        this.getDetailRequest();
      }
    },
  },

  computed: {
    visitorIp() {
      return this.util.getVisitorIp(this.keyInfo);
    },
  },

  methods: {
    closeTrackPopup() {
      this.showTrackPopup = false;
    },
    changeTrackPopup() {
      this.showTrackPopup = true;
    },

    closeDialog() {
      console.log("chatDetail closeDialog");
      this.historyList = [];
      this.$emit("closeDial");
    },

    getHistoryAction() {
      console.log("chatDetail getHistoryAction");
      console.log(this.currentPage, this.totalPage);
      if (this.currentPage <= this.totalPage) {
        this.currentPage = this.currentPage + 1;
        this.isToTop = true;
        this.getHistoryRequest();
      } else {
        this.$message({
          message: "暂无更多历史消息",
          type: "warning",
        });
      }
    },

    async getDetailRequest() {
      console.log(
        "chatDetail getDetailRequest selectedItem = ",
        this.selectItem
      );

      const cid = this.selectItem.cid;
      const csid = this.selectItem.csid;
      const sid = this.selectItem.sid;

      //从变量selectItem中获取
      var api = "/manager/chat/customer/detail";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: cid,
          csid: csid,
          sid: sid,
        },
      });

      console.log("	 = ", response);
      console.log("-----------------------------");
      if (response.resultCode === "10000") {
        console.log("-----------------------------", response);
        const detail = response.data;
        console.log("-----------------------------", 11);
        this.config.name = detail.customerNickname;
        console.log("-----------------------------", 22);
        this.config.mark = detail.customerRemark;
        console.log("-----------------------------", 33);
        this.selectItem.query = detail.query;
        console.log("-----------------------------", 44);
        this.NickName = detail.customerNickname;
        this.MarkName = detail.customerRemark;

        let region = detail.region;
        if (region !== null && region.length > 0) {
          this.config.ipdress = region;
        } else {
          this.config.ipdress = "";
        }
        this.config.sourceProvince = this.util.getVisitorSourceProvince(detail);
        this.config.sourceCity = this.util.getVisitorSourceCity(detail);

        if (detail.source === "") {
          this.config.source = "未知";
        } else {
          this.config.source = this.selectItem.source;
        }
        if (detail.aduserId === "") {
          this.config.aduserId = "无";
        } else {
          this.config.aduserId = detail.aduserId;
        }

        this.config.number = detail.sess_count;
        if (detail.lastLabels !== null) {
          this.config.tags = detail.lastLabels;
        }
        this.keyInfo = detail;

        this.getHistoryRequest(cid, sid, csid);
      } else {
        MessageBox.alert(response.desc, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "error",
          showCancelButton: false,
        });
      }
    },

    async getHistoryRequest() {
      console.log("chatDetail getHistoryRequest page = ", this.currentPage);
      const cid = this.selectItem.cid;
      const csid = this.selectItem.csid;
      const sid = this.selectItem.sid;
      var param = {
          cid: cid,
          csid: csid,
          // sid: sid,
          page: this.currentPage,
          size: this.pageSize,
      }
      if(this.$store.state.isShowSession){
        param = {
          cid: cid,
          csid: csid,
          sid: sid,
          page: this.currentPage,
          size: this.pageSize,
        }
      }
      var api = "/manager/chat/record/list";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: param,
      });
      console.log("chatDrawer getHistoryRequest response = ", response);
      if (response.resultCode === "10000") {
        this.currentPage = response.data.current;
        this.totalPage = response.data.pages;
        if (response.data.list) {
          if (this.isToTop) {
            this.insertRecordList(response.data.list);
            this.allTList.unshift(...response.data.list.reverse());
          } else {
            this.toRecordList(response.data.list);
            this.allTList = response.data.list;
          }
          this.initTextAndTraces(this.allTList);
        } else {
          this.$message({
            message: "暂无更多历史消息",
            type: "warning",
          });
        }
      } else {
        MessageBox.alert(response.desc, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "error",
          showCancelButton: false,
        });
      }
    },

    toRecordList(dataList) {
      if (dataList === null) {
        return;
      }
      // console.log("chatDrawer.vue toRecordList dataList:",dataList)
      for (var i = 0; i < dataList.length; i++) {
        let data = dataList[i];
        var ismine = true;
        var name = "";
        // console.log("chatDrawer.vue toRecordList data.content:",data.content)
        var imgUrl = "";
        if (data.origin === 0) {
          ismine = false;
          name = this.selectItem.cNickName;
        } else {
          // const account = this.util.getLocalAccount()

          if (data.origin === 1  || data.origin === 6) {
            ismine = true;
            name = data.csName;
            if (this.util.nullToString(data.cs_portrait) === "") {
              imgUrl = require("../../static/talks/t_severbig.png");
            } else {
              imgUrl = data.cs_portrait;
            }
          } else if (data.origin === 2) {
            name = data.csName;
            imgUrl = require("../../static/talks/t_robot.png");
          } else if (data.origin === 3 ) {
            name = data.csName;
            imgUrl = require("../../static/talks/t_severbig.png");
            if (this.util.nullToString(data.cs_portrait) !== "") {
              imgUrl = data.cs_portrait;
            }
          }
        }

        //0-客服或客户发的消息 1-系统提醒消息
        var itype = "0";
        if (data.origin === 4 || data.origin === 5) {
          itype = "1";
        }

        var iColor = "0"; //0-正常的聊天信息 1-单消息 2-多消息
        if (data.msgExts !== null) {
          if (data.msgExts.length === 1) {
            iColor = "1";
          } else if (data.msgExts.length > 1) {
            iColor = "2";
          }
        }

        if (data.type === "text") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: data.content,
              type:data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.push(textObj);
        } else if (data.type === "image") {
          let imgText = "<img data-src=" + data.content + ">";
          const imgObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: imgText,
              type:data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.push(imgObj);
        }else if (data.type === "video") {
          let imgText = "<video data-src=" + data.content + ">";
          const imgObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: imgText,
              type:data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.push(imgObj);
        } else if (data.type === "audio") {
          let audioText = "<audio data-src=" + data.content + ">";
          const audioObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: audioText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.push(audioObj);
        } else if (data.type === "card") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: "已经发送留资卡",
              type: data.type,
            },
            mine: false,
            name: name,
            avar: imgUrl,
            type: '1',
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.historyList.unshift(textObj);
        } 
      }

      this.scrolBtm();
    },

    insertRecordList(dataList) {
      if (dataList === null) {
        return;
      }
      // console.log("chatDrawer.vue insertRecordList dataList:",dataList)
      dataList.reverse();
      for (var i = 0; i < dataList.length; i++) {
        let data = dataList[i];
        // console.log("chatDrawer.vue insertRecordList data.content:",data.content)
        var ismine = true;
        var name = "";

        var imgUrl = "";
        if (data.origin === 0) {
          ismine = false;
          name = this.selectItem.cNickName;
        } else {
          // const account = this.util.getLocalAccount()

          if (data.origin === 1 || data.origin === 6) {
            ismine = true;
            name = data.csName;
            if (this.util.nullToString(data.cs_portrait) === "") {
              imgUrl = require("../../static/talks/t_severbig.png");
            } else {
              imgUrl = data.cs_portrait;
            }
          } else if (data.origin === 2) {
            name = data.csName;
            imgUrl = require("../../static/talks/t_robot.png");
          } else if (data.origin === 3) {
            name = data.csName;
            imgUrl = require("../../static/talks/t_severbig.png");
            if (this.util.nullToString(data.cs_portrait) !== "") {
              imgUrl = data.cs_portrait;
            }
          }
        }

        //0-客服或客户发的消息 1-系统提醒消息
        var itype = "0";
        if (data.origin === 4 || data.origin === 5) {
          itype = "1";
        }

        var iColor = "0"; //0-正常的聊天信息 1-单消息 2-多消息
        if (data.msgExts !== null) {
          if (data.msgExts.length === 1) {
            iColor = "1";
          } else if (data.msgExts.length > 1) {
            iColor = "2";
          }
        }

        if (data.type === "text") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: data.content,
              type:data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.unshift(textObj);
        } else if (data.type === "image") {
          let imgText = "<img data-src=" + data.content + ">";
          const imgObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: imgText,
              type:data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.unshift(imgObj);
        } else if (data.type === "video") {
          let imgText = "<video data-src=" + data.content + ">";
          const imgObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: imgText,
              type:data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.unshift(imgObj);
        } else if (data.type === "audio") {
          let audioText = "<audio data-src=" + data.content + ">";
          const audioObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: audioText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            sendStatus: data.sendStatus,
            status: data.status,
          };
          this.historyList.unshift(audioObj);
        }else if (data.type === "card") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: "已经发送留资卡",
              type: data.type,
            },
            mine: false,
            name: name,
            avar: imgUrl,
            type: '1',
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.historyList.unshift(textObj);
        } 
      }
    },

    scrolBtm() {
      const chatscrol = this.$refs.chatlist;
      chatscrol.scrollBottom();
    },

    // scrolTop() {
    //   const chatscrol = this.$refs.chatlist;
    //   chatscrol.scrolTop();
    // },

    loadHistoryHandler() {
      const { historyConfig: { callback = null } = {} } = this.chatListConfig;
      callback && callback();
    },
    bindAddTag(obj) {
      console.log("chatDetail bindAddTag obj = ", obj);
      this.isAddTag = true;
      this.selectedTagList = obj;
      if (this.isAddTag === true) {
        this.getAllTagsRequest();
      }
    },
    async getAllTagsRequest() {
      // 获取标签
      this.usedTagList = [];
      this.allTagList = [];
      console.log("UserItem getTagsRequest");
      var api = "/manager/labelLnUser/settingSwitchAll";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: this.item.cid,
        },
      });
      console.log("index getAllTagsRequest response = ", response);
      if (response.data !== null) {
        for (var i = 0; i < response.data.labelVoFiveList.length; i++) {
          var used = response.data.labelVoFiveList[i];
          used.selected = false;
          for (var k = 0; k < this.selectedTagList.length; k++) {
            var selectedObj = this.selectedTagList[k];
            if (used.id === selectedObj.id) {
              used.selected = true;
            }
          }

          this.usedTagList.push(used);
        }

        for (var j = 0; j < response.data.labelVoAllList.length; j++) {
          var tag = response.data.labelVoAllList[j];
          tag.selected = false;
          for (var m = 0; m < this.selectedTagList.length; m++) {
            var selectedObj1 = this.selectedTagList[m];
            if (tag.id === selectedObj1.id) {
              tag.selected = true;
            }
          }
          this.allTagList.push(tag);
        }
      }
    },
    setTagAction() {
      this.isAddTag = false;
      const account = JSON.parse(localStorage.getItem("account"));

      var lnUsers = [];
      var tags = [];
      console.log("chatDrawer.vue setTagAction usedTagList:", this.usedTagList);
      for (var i = 0; i < this.usedTagList.length; i++) {
        const used = this.usedTagList[i];
        if (used.selected === true) {
          const obj = {
            userId: account.id,
            lableId: used.id,
          };
          lnUsers.push(obj);
          tags.push(used);
        }
      }
      console.log("chatDrawer.vue setTagAction allTagList:", this.allTagList);
      for (var j = 0; j < this.allTagList.length; j++) {
        const tag = this.allTagList[j];
        if (tag.selected === true) {
          const obj = {
            userId: account.id,
            lableId: tag.id,
          };
          lnUsers.push(obj);
          tags.push(tag);
        }
      }
      let arr1 = this.unique1(lnUsers);
      let arr2 = this.unique2(tags);
      console.log("setTag lnusers = ", lnUsers);
      this.setTagRequest(arr1, arr2);
    },

    chooseTag(section, index) {
      console.log("chatDrawer.vue chooseTag section = ", section);
      console.log("chatDrawer.vue chooseTag index = ", index);
      let isChecked = null;
      if (section === 0) {
        const usedTag0 = this.usedTagList[index];
        for (var i = 0; i < this.allTagList.length; i++) {
          var allTag0 = this.allTagList[i];
          if (usedTag0.id === allTag0.id) {
            allTag0.selected = !allTag0.selected;
          }
        }

        usedTag0.selected = !usedTag0.selected;
        // 其他标签选中则取消暂无
        isChecked = this.usedTagList.some((item) => {
          return item.id !== "zanwu" && item.selected === true;
        });
      } else {
        const allTag1 = this.allTagList[index];
        for (var j = 0; j < this.usedTagList.length; j++) {
          var usedTag1 = this.usedTagList[j];
          if (usedTag1.id === allTag1.id) {
            usedTag1.selected = !usedTag1.selected;
          }
        }
        allTag1.selected = !allTag1.selected;
        // 其他标签选中则取消暂无
        isChecked = this.allTagList.some((item) => {
          return item.id !== "zanwu" && item.selected === true;
        });
      }

      // 获取在所有标签中 暂无标签的下标
      zanwu(this.allTagList);
      zanwu(this.usedTagList);
      function zanwu(arr) {
        const z_index = arr.findIndex((item) => {
          return item.id === "zanwu";
        });
        console.log("homeChat chooseTag z_index = ", z_index);
        if (z_index !== -1) {
          if (isChecked) {
            arr[z_index].selected = false;
          } else {
            arr[z_index].selected = true;
          }
        }
      }
    },
    async setTagRequest(users, tagList) {
      console.log("charDrawer.vue setTagRequest users = ", users);
      console.log("charDrawer.vue setTagRequest tagList = ", tagList);
      let labelLnUsers = [];
      // 配合后端取消为空时，传参为暂无
      if (users.length === 0) {
        labelLnUsers = {
          userId: JSON.parse(localStorage.getItem("account")).id,
          lableId: "zanwu",
        };
      } else {
        labelLnUsers = users;
      }
      var api = "/manager/labelLnUser/saveList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          labelLnUsers,
          cid: this.item.cid,
          sid: this.item.sid,
          csid: this.item.csid,
        },
      });
      console.log("charDrawer.vue setTagRequest response = ", response);
      console.log("charDrawer.vue tagList00 = ", tagList);
      console.log(
        'response.resultCode === "10000"',
        response.resultCode === "10000"
      );
      if (response.resultCode === "10000") {
        this.config.tags = [];
        for (var i = 0; i < tagList.length; i++) {
          this.config.tags.push(tagList[i]);
        }
        this.$emit("tagChanged", this.config.tags);
        this.$message.success("添加标签成功");
      } else {
        this.$message.error(response.desc);
      }
    },
    unique1(arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.lableId) && res.set(arr.lableId, 1)
      );
    },

    unique2(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    updateNickname(info) {
      console.log("chatDetail updateNickname", info);
      this.NickName = info;
      this.UpdateNickname = true;
    },
    updateMark(info) {
      console.log("chatDetail updateNickname", info);
      this.MarkName = info;
      this.UpdateMarkname = true;
    },
    async updateNickRequest(source) {
      console.log(
        "chatDetail NickName MarkName",
        this.NickName,
        this.MarkName,
        this.item
      );
      var api = "/manager/session/setCustomerInfo";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: this.item.cid,
          customerNickName: this.NickName,
          customerRemark: this.MarkName,
          sid: this.item.sid,
        },
      });
      console.log("ChatDetail updateNickRequest response ===> ", response);
      if (response.resultCode === "10000") {
        this.UpdateNickname = false;
        this.UpdateMarkname = false;
        this.config.name = this.NickName;
        this.config.mark = this.MarkName;
        // source 0代表修改昵称，1代表修改备注
        if (source === 0) {
          console.log("source----updateNickname--------", source);
          this.$emit("updateNickname", this.NickName);
        } else {
          console.log("source-----updateMark-------", source);
          this.$emit("updateMark", this.MarkName);
        }
        this.$message.success("修改成功");
      } else {
        this.$message.error(response.desc);
      }
    },

    // 复制全文
    copyAlltext() {
      this.$store.state.copyText = this.allText;
      this.$message.success("复制全文成功");
      this.$copyText(this.allText).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },
    // 复制当前浏览url
    copyText(text) {
      this.$store.state.copyText = text;
      this.$message.success("复制链接成功");
      this.$copyText(text).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },

    // 复制轨迹
    copyTraces() {
      this.$store.state.copyText = this.allTraces;
      this.$message.success("复制轨迹成功");
      this.$copyText(this.allTraces).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },

    // 加载消息记录及轨迹
    initTextAndTraces(list) {
      this.allText = "";
      this.allTraces = "";
      let nickname =
        this.selectItem.customer_nickname != null
          ? this.selectItem.customer_nickname
          : "";
      let cid = this.selectItem.cid;

      let keyword = this.selectItem.keyword ? this.selectItem.keyword : "无";
      console.log("---------selectItem:", this.selectItem);
      let searchword = this.selectItem.query ? this.selectItem.query : "无";
      let source = this.selectItem.source;
      let labels = this.getLabels(this.selectItem.labels);

      this.allText =
        "昵称:" +
        nickname +
        "\n" +
        "永久编号:" +
        cid +
        "\n" +
        "搜索词:" +
        searchword +
        "\n" +
        "关键词:" +
        keyword +
        "\n" +
        "来源:" +
        source +
        "\n" +
        "标签:" +
        labels +
        "\n";

      this.allTraces = "昵称：" + nickname + "\n" + "永久编号：" + cid + "\n";
      this.alltrackList = [
        {
          color1: "#000",
          color2: "#000",
          text1: "昵称：",
          text2: nickname,
        },
        {
          color1: "#000",
          color2: "#000",
          text1: "永久编号：",
          text2: cid,
        },
      ];
      if (list != null) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].csName != "") {
            this.allText =
              this.allText +
              list[i].csName +
              " " +
              this.util.timeStampToDate(list[i].timestamp * 1000, 0) +
              " " +
              list[i].content +
              "\n";
          } else {
            this.allText =
              this.allText +
              nickname +
              " " +
              this.util.timeStampToDate(list[i].timestamp * 1000, 0) +
              " " +
              list[i].content +
              "\n";
          }
          if (list[i].origin == 4 || list[i].origin == 5) {
            const tempValue1 =
              this.util.timeStampToDate(list[i].timestamp * 1000, 0) + " ";
            const tempValue2 = list[i].content + "\n";
            this.allTraces = this.allTraces + tempValue1 + tempValue2;
            this.alltrackList.push({
              color1: "#1577d2",
              color2: "rgb(248, 90, 90)",
              text1: tempValue1,
              text2: tempValue2,
            });
          }
        }
      }

      console.log("this.allTraces", this.allTraces);
    },

    // 获取用户标签
    getLabels(list) {
      let labels = "";
      if (list != []) {
        for (let i = 0; i < list.length; i++) {
          labels = labels != "" ? labels + " " + list[i].name : list[i].name;
        }
      } else {
        labels = "";
      }
      return labels;
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
// :deep() .el-dialog {
//   /* width: 90%;
// 		height: 90%; */
//   margin-top: 30px !important;
// }

.ChatPage {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.header {
  height: auto;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.3125rem;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0 12px;
}

.header_line {
  width: 100%;
  height: 4px;
  background-color: #e2e8f0;
  z-index: 1;
}

.key_container {
  @include change_tip_size($tip_size_normal);
  width: 90%;
  // max-height: 90px;
  // background-color: #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
}

.key_div {
  width: 90%;
  // height: 5.25rem;
  background-color: #e2e8f0;
  border-radius: 4px;
  margin-top: 0.625rem;
}

.key_container1 {
  @include change_tip_size($tip_size_normal);
  width: 90%;
  // max-height: 90px;
  // background-color: #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
}

.key_div1 {
  /* width: 90%; */
  width: auto;
  height: auto;
  background-color: #e2e8f0;
  border-radius: 4px;
  margin-top: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.key_container2 {
  width: 90%;
  // max-height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
}

.key_div2 {
  width: auto;
  height: auto;
  background-color: #e2e8f0;
  border-radius: 4px;
  margin-top: 0.625rem;
}

.keyword {
  width: 100%;
  height: 2.0625rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.otherInfo {
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 1.875rem;
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.history_div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.25rem;
  cursor: pointer;
  /* background-color: cyan; */
}

.history_lb {
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 0.5rem;
  cursor: pointer;
}

.brow_lb {
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 0.625rem; */
  padding-left: 1.25rem;
  white-space: nowrap;
}

.url_lb {
  max-width: 11.25rem;
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-decoration: underline;
  text-decoration-color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  /* background-color: yellow; */
  /* height: 1.5625rem; */
  /* width: 16.25rem; */
  text-align: left;
  white-space: nowrap;
}

.site_lb {
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 1.25rem;
  padding-right: 1.25rem;
  white-space: nowrap;
}

.key_lb {
  width: 50%;
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: left;
  padding-left: 1.25rem;
  padding-top: 1rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.keyword1 {
  width: 100%;
  /* height: 2.0625rem; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.brow_lb1 {
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 0.625rem; */
  padding-left: 1.25rem;
  // padding-right: 1.25rem;
  white-space: nowrap;
}

.site_lb1 {
  // font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 1.875rem; */
  margin-left: 1.5rem;
  padding-right: 1.25rem;
  white-space: nowrap;
}

.key_lb1 {
  // font-size: 12px;
  max-width: 180px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: left;
  padding-left: 1.25rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.keyword2 {
  width: 100%;
  /* height: 2.0625rem; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.brow_lb2 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 0.625rem; */
  text-align: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  white-space: nowrap;
}

.site_lb2 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 1.875rem; */
  text-align: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  white-space: nowrap;
}

.key_lb2 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.chatPage {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  /* background: orange; */
}

.chatBox {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.taleBox {
  overflow: auto;
  width: 100%;
  flex: 1;
  min-height: 0;
}

.taleBox::-webkit-scrollbar {
  display: none;
}

.common_div,
.all_div {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: 30%;
  padding: 10px;
}

.all_div {
  margin-top: 20px;
}

.tag_lb {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 0.8);
  margin-bottom: 15px;
}

.tag_box {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.tag_btn,
.tag_selected {
  margin-bottom: 0.625rem;
  line-height: 1.25rem;
  padding: 0.3125rem 0.625rem;
  background: #f4f7fb;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  margin-left: 0.625rem;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 0.5);
  cursor: pointer;
}

.tag_selected {
  background-color: #ffffff;
}

:deep() .el-drawer__wrapper {
  width: 50% !important;
  margin-left: 50%;
}
:deep() .el-drawer__header {
  margin-bottom: 0rem;
  padding: 8px 16px 0;
}
:deep() .el-drawer__body {
  height: calc(100% - 40px);
  overflow: hidden;
  padding: 0;
}

html[data-compact="1"] {
  .header {
    margin-bottom: 0;
    padding: 0 8px;
  }
  .header_line {
    height: 2px;
  }
  .key_container,
  .key_container1,
  .key_container2 {
    width: 98%;
  }
  .key_div,
  .key_div1,
  .key_div2 {
    margin-top: 4px;
  }
  .history_div {
    height: 22px;
  }
  .history_div img {
    width: 12px !important;
    height: 12px !important;
  }
  .history_lb {
    font-size: 11px !important;
    margin-left: 4px;
  }
  .key_lb,
  .key_lb1,
  .key_lb2,
  .brow_lb,
  .brow_lb1,
  .brow_lb2,
  .url_lb,
  .site_lb,
  .site_lb1,
  .site_lb2,
  .keyword,
  .keyword1,
  .keyword2 {
    font-size: 11px !important;
  }
  .otherInfo {
    margin-top: 2px;
    margin-bottom: 2px;
  }
  :deep() .el-drawer__header {
    padding: 4px 10px 0;
  }
  :deep() .el-drawer__close-btn {
    font-size: 16px;
  }
}

/* 显示完整url地址 */
.url-allShow {
  @include change_tip_size($tip_size_normal);
  display: flex;
  flex-direction: column;
  & > span:nth-of-type(1)::after {
    display: block;
    content: "";
    width: 100px;
    margin: 4px 0;
    border-top: 1px solid #ccc;
  }
}
.url-copy {
  cursor: pointer;
  color: #1677d2;
}

::v-deep .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
  .trackList {
    @include change_size($font_size_normal);
    line-height: 2;
    color: #000;
  }
}
</style>
